import Button from "components/base/Button";
import localforage from "localforage";

const DeveloperView = () => {
  function resetDb() {
    localforage.clear().then(() => {
      window.location.reload();
    });
  }

  return (
    <div className="card">
      <h5>Developer</h5>
      <div className="mt-2">
        <Button onClick={resetDb}>Reset IndexedDB</Button>
      </div>
    </div>
  );
};

export default DeveloperView;
